import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  sidebarCollapsed: boolean;
  themeMode: 'light' | 'dark' | 'system';
  setSidebarCollapsed: (b: boolean) => void;
  toggleSidebar: () => void;
  setThemeMode: (m: 'light' | 'dark' | 'system') => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      themeMode: 'system',
      setSidebarCollapsed: (b) => set({ sidebarCollapsed: b }),
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
      setThemeMode: (m) => set({ themeMode: m }),
    }),
    { name: 'nhfb-admin-ui' },
  ),
);
